import { createAction, props } from '@ngrx/store';

import { PeopleTab } from '../../../customization/components/customization-people-container/interfaces';

export const selectPeopleTab = createAction('[PeoplePage] select tab', props<{ tab: PeopleTab }>());
export const initSelectedPeopleTab = createAction('[PeoplePage] init selected tab', props<{ tab: PeopleTab }>());
